import {
  getRecentJournals,
  getUploads,
  postUpload,
  putUpload,
} from "../../api/uploads";
import { createSliceWithThunks } from "../utils";

const initialState = {
  get: {
    list: null,
    status: "idle",
    error: null,
  },
  getRecentJournals: {
    list: null,
    status: "idle",
    error: null,
  },
  getBase64: {
    list: null,
    status: "idle",
    error: null,
  },
  post: {
    data: null,
    status: "idle",
    error: null,
  },
  put: {
    data: null,
    status: "idle",
    error: null,
  },
};

export const uploadSlice = createSliceWithThunks({
  name: "uploadSlice",
  initialState: initialState,
  reducers: (create) => ({
    resetStateUploads: create.reducer((state, { payload }) => {
      if (payload) {
        for (let key in payload) {
          state[`${payload[key]}`] = initialState[`${payload[key]}`];
        }
      } else {
        for (let key in initialState) {
          state[key] = initialState[key];
        }
      }
    }),
    //* thunks
    fetchUploads: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getUploads(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.get.status = "loading";
        },
        rejected: (state, action) => {
          state.get.status = "failed";
          state.get.error = { message: "Something went wrong" };
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.get.error = { message: respObj };
            } else if (status === "success") {
              state.get.list = respObj;
            }
          } else {
            state.get.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.get.status = "idle";
        },
      }
    ),
    fetchRecentJournals: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getRecentJournals(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.getRecentJournals.status = "loading";
        },
        rejected: (state, action) => {
          state.getRecentJournals.status = "failed";
          state.getRecentJournals.error = { message: "Something went wrong" };
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.getRecentJournals.error = { message: respObj };
            } else if (status === "success") {
              state.getRecentJournals.list = respObj;
            }
          } else {
            state.getRecentJournals.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.getRecentJournals.status = "idle";
        },
      }
    ),
    uploadData: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postUpload(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err?.response?.data?.message || err.message);
        }
      },
      {
        pending: (state) => {
          state.post.status = "loading";
        },
        rejected: (state, action) => {
          state.post.status = "failed";
          state.post.error = { message: action.payload || action.error?.message || "An error occurred" };
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.post.error = { message: respObj };
            } else if (status === "success") {
              state.post.data = respObj;
            }
          } else {
            state.post.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.post.status = "idle";
        },
      }
    ),
    updateUpload: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await putUpload(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err?.response?.data?.message || err.message);
        }
      },
      {
        pending: (state) => {
          state.put.status = "loading";
        },
        rejected: (state, action) => {
          state.put.status = "failed";
          state.put.error = { message: action.payload || action.error?.message || "An error occurred" };
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.put.error = { message: respObj };
            } else if (status === "success") {
              state.put.data = respObj;
            }
          } else {
            state.put.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.put.status = "idle";
        },
      }
    ),
  }),
});

export const {
  fetchUploads,
  fetchRecentJournals,
  fetchUploadData,
  uploadData,
  updateUpload,
  resetStateUploads,
} = uploadSlice.actions;
export default uploadSlice.reducer;
